{
  "setupWorkplaceStep": {
    "title": "¡Vamos a configurar tu lugar de trabajo!",
    "description": "Debes completar los siguientes tres pasos para crear un lugar de trabajo",
    "pill": {
      "setupNow": "Configurar ahora"
    },
    "options": {
      "sso": {
        "title": "Conecta tu SSO",
        "description": "Configura el inicio de sesión único para gestionar el acceso de tu organización.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Administrar"
      },
      "orgChat": {
        "title": "Conecta tu organigrama",
        "description": "Importa la estructura de tu organización para habilitar flujos de trabajo automatizados.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      },
      "communicationTool": {
        "title": "Conecta herramienta de comunicación",
        "description": "Recoge comentarios de los empleados con las plataformas de comunicación de tu equipo.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      },
      "billing": {
        "title": "Configura la facturación",
        "description": "Agrega tu información de facturación y elige un plan que se adapte a tus necesidades.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      }
    }
  },
  "connectSsoStep": {
    "title": "Conecta tu proveedor de SSO",
    "description": "Configura el inicio de sesión único para gestionar el acceso de tu organización",
    "backButton": "Volver a la configuración",
    "options": {
      "domain": {
        "title": "Verificar el dominio de la organización",
        "buttonLabel": "Verificar"
      },
      "provider": {
        "title": "Configurar el proveedor de identidad",
        "buttonLabel": "Configurar"
      }
    }
  },
  "connectOrgChatStep": {
    "title": "Conecta tu organigrama",
    "description": "Importa la estructura de tu organización para habilitar flujos de trabajo automatizados",
    "backButton": "Volver a la configuración",
    "options": {
      "workday": { "title": "Workday", "buttonLabel": "Conectar" },
      "bamboo": { "title": "BambooHR", "buttonLabel": "Conectar" }
    }
  },
  "connectCommunicationToolStep": {
    "title": "Conecta tu herramienta de comunicación",
    "description": "Todas las preguntas diarias se recopilarán de la herramienta de comunicación que uses",
    "backButton": "Volver a la configuración",
    "options": {
      "slack": { "title": "Slack", "buttonLabel": "Conectar" },
      "teams": { "title": "Microsoft Teams", "buttonLabel": "Conectar" }
    }
  },
  "billingStep": {},
  "alertDialog": {
    "trigger": "Configurar más tarde",
    "title": "¿Quieres omitir la configuración?",
    "description": "Omitir la configuración significa que deberás configurar tu espacio de trabajo más adelante. Algunas funciones podrían no estar disponibles hasta que completes la configuración.",
    "actionButton": "Continuar con la configuración",
    "cancelButton": "Omitir configuración"
  }
}
